export default "__VITE_PUBLIC_ASSET__5568b664__"